<template>
    <table class="table table-striped additions-table">
        <thead>
        <tr>
            <th colspan="3">{{trans.attendance.statistics.personal_bonus}}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <th>
                <input
                        type="text"
                        class="form-control"
                        v-model="newBonusTitle"
                        :placeholder="trans.attendance.note"
                        :disabled="newBonusLoading"
                        :class="{'loading disabled': newBonusLoading }"
                />
            </th>
            <td style="width: 40%;">
                <div class="input-group">
                    <input
                            type="number"
                            class="form-control"
                            v-model="newBonusAmount"
                            :disabled="newBonusLoading"
                            :class="{'loading disabled': newBonusLoading }"
                    >
                    <div class="input-group-append">
                                    <span class="input-group-text">
                                        {{ restaurantCurrency }}
                                    </span>
                    </div>
                </div>
            </td>
            <td style="width: 10%;">
                <button
                        @click="addPersonalBonus()"
                        type="button"
                        class="btn btn-success btn-square-loading-save"
                        :class="{'loading disabled': newBonusLoading }"
                >
                    <i class="fal fa-save" v-if="!newBonusLoading"></i><i class="loadingSpinner"></i>
                </button>
            </td>
        </tr>


        <tr v-for="bonus in attendance.personalBonuses">
            <td>{{ (bonus.title ? bonus.title : trans.attendance.statistics.personal_bonus) }}</td>
            <td style="white-space: nowrap;" class="text-right">
                <span>{{ bonus.amount }}&nbsp;{{ restaurantCurrency }}</span>
            </td>
            <td class="text-center" style="white-space: nowrap;">
                <button class="btn btn-link p-0" @click="deletePersonalBonus(bonus.id)" :disabled="bonusesLoading.some(id => id === bonus.id)">
                    <i class="fas fa-spinner text-danger" v-if="bonusesLoading.some(id => id === bonus.id)"></i>
                    <i class="fal fa-fw fa-trash-alt text-danger" v-else></i>
                </button>
            </td>
        </tr>
        <tr>
            <td>{{trans.attendance.extra_shifts}}</td>
            <td class="text-right" style="white-space: nowrap;">
                <span>{{  attendance.sum_of_daily_personal_bonuses ? attendance.sum_of_daily_personal_bonuses.toFixed(2) : 0}}&nbsp;{{ restaurantCurrency }}</span>
            </td>
            <td></td>
        </tr>
        <tr>
            <td>{{trans.attendance.uniform_bonus}}</td>
            <td class="text-right" style="white-space: nowrap;">
                <span>{{  (attendance.uniformPersonalBonus) ? attendance.uniformPersonalBonus.toFixed(2) : 0}}&nbsp;{{ restaurantCurrency }}</span>
            </td>
            <td></td>
        </tr>
        <!--<tr v-if="contractSettings.mealVoucherClaim == 1 && attendance.meal_vouchers_type == 2">
            <td>{{trans.attendance.meal_vouchers}}</td>
            <td class="text-right" style="white-space: nowrap;">
                <span>{{  (attendance.meal_vouchers_personal_bonus) ? attendance.meal_vouchers_personal_bonus.toFixed(2) : 0}}&nbsp;{{ restaurantCurrency }}</span>
            </td>
            <td></td>
        </tr>-->
        <tr>
            <td style="width: 50%"><b>{{trans.attendance.bonuses_together}}:</b></td>
            <td class="text-right" style="white-space: nowrap;">
                <b>{{attendance.monthly_personal_bonus.toFixed(2)}}&nbsp;{{ restaurantCurrency }}</b>
            </td>
            <td></td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        name: 'personal-bonuses',
        data: function() {
            return {
                newBonusLoading: false,
                bonusesLoading: [],
                newBonusAmount: 0,
                newBonusTitle: '',
            }
        },

        props: {
            'attendance': {
                type: Object
            },
            'trans': {
                type: Object
            },
            'restaurantCurrency': {
                type: String
            },
            'bonusesUrlStore': {
                type: String
            },
            'bonusesUrlDestroy': {
                type: String
            },
            'contractSettings': {
                type: Object
            }
        },

        methods: {
            addPersonalBonus() {
                const data = {
                    amount: this.newBonusAmount,
                    title: this.newBonusTitle
                };

                this.newBonusLoading = true;
                // TODO: correct URL once API is finished
                axios.post(this.bonusesUrlStore, data).then(response => {
                    this.refreshAttendance();
                    this.$notify({ type: 'success', title: 'Success!', text: response.data.message ? response.data.message : 'Item successfully updated.' });
                    this.newBonusLoading = false;
                    this.newBonusAmount = 0;
                    this.newBonusTitle = '';

                }, error => {
                    this.newBonusLoading = false;
                    this.$notify({ type: 'error', title: 'Error!', text: error.response.data.message ? error.response.data.message : 'An error has occured.' });
                })
            },
            deletePersonalBonus(bonusId) {
                this.bonusesLoading.push(bonusId);
                // TODO: correct URL once API is finished
                axios.post(this.bonusesUrlDestroy.replace("%ID%",bonusId)).then(response => {
                    this.bonusesLoading = this.bonusesLoading.filter(id => id !== bonusId);
                    this.refreshAttendance();
                    this.$notify({ type: 'success', title: 'Success!', text: response.data.message ? response.data.message : 'Item successfully updated.' });
                }, error => {
                    this.bonusesLoading = this.bonusesLoading.filter(id => id !== bonusId);
                    this.$notify({ type: 'error', title: 'Error!', text: error.response.data.message ? error.response.data.message : 'An error has occured.' });
                })
            },
            refreshAttendance(withLoading = true) {
                this.$parent.$emit('refreshattendance', withLoading);
            }
        }
    }
</script>


<style lang="scss" scoped>
    .btn-square-loading-save,
    .btn.loading.btn-square-loading-save {
        width: 38px;
        height: 35px;
        padding-right: 0.75rem !important;
        text-align: center;

        .loadingSpinner {
            margin-left: -10px;
            left: auto;
            right: auto;
        }
    }
    .form-control {
        padding-right: 12px !important;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/attendance/show/PersonalBonuses.vue